import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve } from "@angular/router";
import { Observable } from "rxjs";
import { IndicadoresAtividadeSituacaoService } from "../services/indicadores-atividade-situacao.service";

@Injectable({
  providedIn: 'root'
})
export class IndicadoresAtividadeSituacaoListResolver implements Resolve<boolean> {

  constructor(private service: IndicadoresAtividadeSituacaoService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getByIdListEdit(route.params.id);
  }
}

@Injectable({
  providedIn: 'root'
})
export class IndicadoresAtividadeSituacaoResolver implements Resolve<boolean> {

  constructor(private service: IndicadoresAtividadeSituacaoService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getById(route.params.id);
  }
}